import Context from './Context';
import _ from 'lodash';

export default class SecurityManager {

    constructor(me) {

        if (!me)
            throw new Error("The Security object requires an user to be initialized");

        this.me = me;
        this.role = me.role && me.role.name;
        this.permissions = me.permissionsArray || [];
    }

    havePermission($permission) {
        if (this.isSuperAdmin())
            return true;
        return _.includes(this.permissions, $permission);
    }

    haveAtLeastOnePermission($permissions) {
        if (this.isSuperAdmin())
            return true;
        return _.intersection(this.permissions, $permissions).length > 0
    }

    isActualUser(user) {
        if (this.isSuperAdmin())
            return true;
        return !!(user && user.id === this.me.id)
    }

    isSuperAdmin() {
        return this.role === 'SUPER_ADMIN';
    }

    isMember() {
        return this.role === 'MIEMBRO';
    }

    core = {
        canSeePayments: () => this.havePermission('PAYMENT_LIST'),
        canManagePayments: () => this.havePermission('PAYMENT_CREATE'),
        canListMembers: () => this.havePermission('PEOPLE_LIST'),
        canManageMembers: () => this.havePermission('PEOPLE_UPDATE'),
        canSeeReports: () => this.havePermission('REPORTS_DOWNLOAD'),
        canSendEmails: () => this.havePermission('EMAIL_SEND'),
        canViewLibrary: () => this.havePermission('LIBRARY_VIEW'),
        canManageAdminUsers: () => this.havePermission('MANAGE_ADMIN_USERS'),
        canEditPermissions: () => this.isSuperAdmin(),
        canManageCongresses: () => this.isSuperAdmin(),
        canManageEvents: () => this.isSuperAdmin(),
        canManageCertificates: () => this.isSuperAdmin(),
        canManageGeneralPeople: () => this.isSuperAdmin()
    };
}

export const SecurityContext = Context;


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/services/SecurityManager.js